var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix_",staticStyle:{"background":"#fff"},attrs:{"id":"app"}},[(_vm.isBlock1)?_c('div',[_c('headerNav')],1):_vm._e(),_vm._v(" "),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.isBlock2)?_c('pcFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e19d26d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 